import React, { useEffect, useState } from 'react';
import { AppDispatch, useAppSelector } from '../../../../../../redux/store';
import { useDispatch } from 'react-redux';
import {
  getCategoriesProductAsync,
  getPizzasAsync,
  getProductAsync,
  getAllProductsAsync
} from '../../../../../../redux/features/product/services';
import { ModalFamily } from './ModalFamily';
import {
  addProductTable,
  addProductTableComments,
  addProductTableEdges,
  addProductTableExtras,
  removeSelectedComments,
  removeSelectedEdges,
  removeSelectedExtras,
  removeSelectedProducts,
  setPrice,
  setProduct,
} from '../../../../../../redux/features/product/product-slice';
import { notifyError, notifyWarning } from '../../../../../notify/notify-component';
import { IActivedTab } from '../index';
import { ModalProducts } from '../NavbarIntern/ModalProducts';

interface IProps {
  activedtab: IActivedTab;
}

export function FooterIntern({ activedtab }: IProps) {
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const { categories, pizzas, selectedRows, product, price, flavors, edges, extras, comments, allProducts } = useAppSelector(
    ({ productReducer }) => productReducer.value
  );

  const [open, setOpen] = useState<boolean>(false);
  const [openPizzas, setOpenPizzas] = useState<boolean>(false);

  const getProductCategories = () => {
    setOpen(true);
  };

  const getProductPizza = () => {
  console.log('🖱️ [FooterIntern] getProductPizza chamado');
  console.log('📋 [FooterIntern] allProducts atual:', allProducts?.length);

  if (!allProducts || allProducts.length === 0) {
    console.log('📡 [FooterIntern] Cache vazio — disparando getAllProductsAsync...');
    dispatch(
      getAllProductsAsync({
        storeId: storeMe?.storeActive?.id ?? 0,
        isComplement: !!activedtab?.comentario,
      })
    );
  } else {
    console.log('⚡ [FooterIntern] Usando cache — sem requisição');
  }
  setOpenPizzas(true);
};

  const handleClose = () => {
    setOpen(false);
  };

  const handleClosePizza = () => {
    setOpenPizzas(false);
  };

  const handleRemoveSelected = () => {
    if (selectedRows.length === 0) return notifyWarning('Nenhum item selecionado!');
    if (activedtab.sabores) {
      dispatch(removeSelectedProducts());
    }

    if (activedtab.borda) {
      dispatch(removeSelectedEdges());
    }

    if (activedtab.extra) {
      dispatch(removeSelectedExtras());
    }
    if (activedtab.comentario) {
      dispatch(removeSelectedComments());
    }
  };

  const handleToRecord = () => {
    if (product?.length === 0 || product === null) return notifyWarning('Nenhum item selecionado!');

    // Verifica se é um array de produtos (seleção múltipla) ou um único produto
    const productsToAdd = Array.isArray(product) && !product.hasOwnProperty('id_pdv') ? product : [product];

    let addedCount = 0;
    let skippedCount = 0;

    productsToAdd.forEach((prod: any) => {
      if (activedtab.sabores) {
        const hasProduct = flavors.find((item: any) => item?.ItemKeyId === prod?.id_pdv?.toString());
        if (hasProduct) {
          notifyWarning(`Produto "${prod.sale_name}" já cadastrado`);
          skippedCount++;
          return;
        }

        const newProduct: any = {
          ...prod,
          sale_price: price ?? prod?.sale_price,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.description,
          Price: price ?? prod?.sale_price,
          Type: 1,
        };
        dispatch(addProductTable(newProduct));
        addedCount++;
      }

      if (activedtab.borda) {
        const hasProduct = edges.find((item: any) => item?.ItemKeyId === prod?.id_pdv?.toString());
        if (hasProduct) {
          notifyWarning(`Produto "${prod.sale_name}" já cadastrado`);
          skippedCount++;
          return;
        }

        const newProduct: any = {
          ...prod,
          sale_price: price ?? prod?.sale_price,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.description,
          Price: price ?? prod?.sale_price,
          Type: 2,
        };
        dispatch(addProductTableEdges(newProduct));
        addedCount++;
      }

      if (activedtab.extra) {
        const hasProduct = extras.find((item: any) => item?.ItemKeyId === prod?.id_pdv?.toString());
        if (hasProduct) {
          notifyWarning(`Produto "${prod.sale_name}" já cadastrado`);
          skippedCount++;
          return;
        }

        const newProduct: any = {
          ...prod,
          sale_price: price ?? prod?.sale_price,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.description,
          Price: price ?? prod?.sale_price,
          Type: 3,
        };
        dispatch(addProductTableExtras(newProduct));
        addedCount++;
      }

      if (activedtab.comentario) {
        const hasProduct = comments.find((item: any) => item?.ItemKeyId === prod?.id_pdv?.toString());
        if (hasProduct) {
          notifyWarning(`Produto "${prod.sale_name}" já cadastrado`);
          skippedCount++;
          return;
        }

        const newProduct: any = {
          ...prod,
          sale_price: price ?? prod?.sale_price,
          ItemKeyId: prod?.id_pdv?.toString(),
          ItemDescription: prod.sale_name,
          Description: prod.description,
          Price: price ?? prod?.sale_price,
          Type: 4,
        };
        dispatch(addProductTableComments(newProduct));
        addedCount++;
      }
    });

    // Mensagem de feedback ao usuário
    if (addedCount > 0) {
      const message = addedCount === 1 
        ? 'Produto adicionado com sucesso!' 
        : `${addedCount} produtos adicionados com sucesso!`;
      // Você pode criar uma notifySuccess se não existir
      console.log(message);
    }

    if (skippedCount > 0 && addedCount === 0) {
      notifyError('Todos os produtos selecionados já estavam cadastrados');
    }

    dispatch(setProduct([]));
    dispatch(setPrice(undefined));
  };

  useEffect(() => {
    dispatch(getCategoriesProductAsync(storeMe?.storeActive?.id));
    dispatch(getPizzasAsync({ storeId: storeMe?.storeActive?.id }));
  }, [dispatch]);

  return (
    <>
      <ModalFamily
        activedtab={activedtab}
        show={open}
        handleClose={handleClose}
        categories={categories}
        dispatch={dispatch}
        storeId={storeMe?.storeActive?.id}
      />
      <ModalProducts
        show={openPizzas}
        handleClose={handleClosePizza}
        dispatch={dispatch}
        storeId={storeMe?.storeActive?.id}
        activedtab={activedtab}
      />
      <footer>
        {/* <button type="button" onClick={handleToRecord}>
          Gravar
        </button> */}
        <button type="button" onClick={handleRemoveSelected}>
          Remover
        </button>
        <button type="button" onClick={getProductPizza}>
          Importar Item
        </button>
        <button type="button" onClick={() => getProductCategories()}>
          Importar Família.
        </button>
      </footer>
    </>
  );
}